import { Component, OnInit, ViewEncapsulation, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'photo-input',
  templateUrl: './photo-input.component.html',
  styleUrls: ['./photo-input.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PhotoInput implements OnInit {

  @ViewChild("fileInput") fileInput: ElementRef;
  images:any = [];
  files:any = [];
  defaultText = "Choose a file";
  defaultTextUploaded = "#FILES file(s) uploaded";

  labelText = "";
  id;
  

  // Limit the amount of photos that the element will allow to be uploaded.
  @Input() photoLimit: number = 10;

  // The quality of the photos (% or px)
  // E.g. Photo Dimentions = 500x250.
  //  100% = 500x250
  //  50% = 250x125
  //  250px = 250x125
  //  150px = 150x75
  @Input() photoQuality: string = "100%";

  // Change the text of the button when no files are uploaded.
  // E.g. 'Upload a file'
  @Input() label: string;
  // Change the text when you have items on the element (#FILES will be replaced with the number of files uploaded.)
  // E.g. 'Uploaded (#FILES)' would get changed to 'Uploaded (2)' if the file array length is 2.
  @Input() labelUploaded: string;

  @Output() fileOutput:EventEmitter<FileList> = new EventEmitter();
  constructor() { 
    
  }

  ngOnInit() {
    this.displayText();
  }

  displayText() {
    if(this.images.length == 0) {
      this.labelText = this.label ? this.label : this.defaultText;
    } else {
      if(this.labelUploaded) {
        this.labelText = this.labelUploaded.replace("#FILES", this.files.length);
      } else {
        this.labelText = this.defaultTextUploaded.replace("#FILES", this.files.length);
      }
    }
  }

  getID() {
    return this.id ? this.id : this.id = "photo-input-" + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6);
  }

  removeFile(index) {
    this.files.splice(index, 1);
    this.images.splice(index, 1);
    this.outputFiles();
    this.displayText();
  }

  filesChange($event) {
    let uploadedFiles = $event.target.files;
  
    let reader = new FileReader();
    let _root = this;
    let filesRead = 0;
    
    reader.onload = function(e:any) {
      let image = new Image();
      image.onload = function(eImg:any) {
        let canvas = document.createElement('canvas');
        let width = image.width, height = image.height;
        
        if(_root.photoQuality.includes("%")) {
          let scale = parseFloat(_root.photoQuality.slice(0, -1)) / 100;
          width *= scale;
          height *= scale;
        } else if(_root.photoQuality.includes("px")) {
          let maxSideSize = parseInt(_root.photoQuality.slice(0, -2));
          if(width > height) {
            height *= (maxSideSize / width);
            width = maxSideSize;
          } else {
            width *= (maxSideSize / height);
            height = maxSideSize;
          }
        }
        //console.log("Resizing image " + _root.photoQuality  + ". Old: " + image.width + "x" + image.height + ". New: " + width + "x" + height);
        canvas.width = width;
        canvas.height = height;
        //canvas.getContext('2d').fillStyle = 'rgba(255,255,255,1)';
        //canvas.getContext('2d').fillRect(0,0,width,height);
        canvas.getContext('2d').drawImage(image, 0, 0, width, height);
        let dataUrl = canvas.toDataURL('image/png');

        filesRead++;

        if(!_root.images.includes(dataUrl) && _root.files.length < _root.photoLimit) {
          _root.images.unshift(dataUrl);

          let blobBin = atob(dataUrl.split(',')[1]);
          let array = [];
          for(let i = 0; i < blobBin.length; i++) {
              array.push(blobBin.charCodeAt(i));
          }
          let file = new Blob([new Uint8Array(array)], {type: 'image/png'});
          _root.files.unshift(file);
        }

        if(filesRead < uploadedFiles.length) {
          reader.readAsDataURL(uploadedFiles[filesRead]);
        } else {
          _root.outputFiles();
          _root.displayText();
        }
      }
      image.src = e.target.result;
    } 
    
    reader.readAsDataURL(uploadedFiles[0]);
  }

  outputFiles() {
    this.fileOutput.emit(this.files);
    console.log(this.files);
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/photo-input/photo-input.component.ts